export const Paths = {
  Root: '/',
  Home: '/home',
  Login: '/login',
  RecoveryPassword: '/recovery-password/:token',
  Partner: '/parceiro',
  AdminPartners: '/admin/parceiros',
  AdminSellers: '/admin/parceiros/vendedores',
  AdminContracts: '/admin/parceiros/contratos',
  AdminPayments: '/admin/parceiros/pagamentos',
  AdminWithdrawals: '/admin/parceiros/saques',
};
